<style lang="scss" scoped>
  @import '../../sass/variables';

  .the-header {
    padding: 20px 28px;
    border-radius: 24px;
    margin-top: 16px;
    margin-bottom: 8px;
    background-color: $salesflow-primary;
    display: flex;
    flex-wrap: wrap;
    align-self: center;

    form.search {
      input {
        display: inline-block;
        background: transparent;
        border: none;
        color: $white-gray;
        border-bottom: 1px solid $white-gray;
        width: 274px;
        padding: 0.375rem 0.75rem;
        font-size: 0.75rem;
        font-weight: 700;
        line-height: 1.5;
        outline: 0;

        &::placeholder,
        &::-webkit-input-placeholder {
          color: $white-gray;
        }
      }

      @media (max-width: 1439px) {
        .leads-search {
          width: auto;
        }
      }

       @media (max-width: 1350px) {
        .leads-search {
          width: 165px;
        }
      }

      button {
        margin-left: 5px;
        display: inline-block;
        border: none;
        background: transparent;
      }
    }

    > .nav {
      flex-direction: row;
      display: flex;
      list-style: none;
      align-items: center!important;

      > .nav-item,
      > .nav-action {
        &:first-child {
          padding-left: 0;
        }
        &:last-child {
          padding-right: 0;
        }
      }

      > .nav-item {
        padding: 0 0.5rem;

        > .nav-link {
          color: #f6f5f8;
          font-family: Montserrat;
          font-size: 0.75rem;
          font-weight: 600;
          letter-spacing: 0.22px;
          line-height: 100%;
          padding: 0;
          svg {
            margin-right: 10px;
          }
        }
      }

      > .nav-action {
        padding: 0 0.75rem;
        .icon {
          cursor: pointer;
        }

        .avatar {
          border-radius: 100%;
          width: 45px;
        }
      }

      > .nav-profile {
        display: flex;
        align-items: center;
        .name,
        .toggle-dropdown {
          color: #f6f5f8;
          transition: transform 250ms ease-in-out;
        }

        .name {
          font-family: Montserrat;
          margin-left: 4px;
          font-size: 0.685rem;
          font-weight: 700;
          letter-spacing: 0.22px;
          padding: 0 0.35rem;
        }

        > a {
          display: flex;
          align-items: center;

          &:hover {
            text-decoration: none;
          }
        }

        > .dropdown-menu {
          width: auto;
          padding: unset;
          overflow: unset;
          margin-top: 5px;
          display: none;

          > .multiselect__option:hover {
              color: #3B334A;
              background: #EAE6F0;
              text-decoration: none;
          }
        }

        > .dropdown-menu.show {
          display: block;
          z-index: 100;
        }

        .multiselect__content-wrapper:before {
          margin-top: -5px;
          right: -1px;
        }

        &.show {
          .toggle-dropdown {
            transform: rotate(180deg);
          }
        }
      }
    }

    .trial {
      span {
        font-family: Montserrat;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.2px;
        line-height: 25px;
        text-transform: uppercase;
      }
    }

    @media (max-width: 1509px) {
      button#sign {
        padding: 0.25rem 0.5rem;
        font-size: 0.65625rem;
        line-height: 1.5;
      }

      .trial {
        padding-left: 0px !important;
        font-size: 0.65625rem;
      }
    }
  }
</style>

<template>
  <div
    class="the-header compensate-padding-right"
    id="the-header"
  >
    <ul class="nav">
      <li class="nav-item">
        <a
          class="nav-link"
          href="#"
          @click.prevent="toggleCreateLeadButton()"
          data-ignore-unsaved-check
        >
          <IconPlus
            color="#f6f5f8"
            :size="10"
          />{{ __('Adicionar lead') }}</a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          href="#"
          @click.prevent="toggleImportLeadButton()"
          data-ignore-unsaved-check
        >
          <IconDownload
            color="#f6f5f8"
            :size="12"
          />{{ __('Importar leads') }}</a>
      </li>

      <li class="nav-item">
        <a
          class="nav-link"
          href="#"
          @click.prevent="toggleCreateDealButton()"
          data-ignore-unsaved-check
        >
          <IconPlus
            color="#f6f5f8"
            :size="10"
          />{{ __('Novo negócio') }}</a>
      </li>
      <!-- <li
        class="nav-item"
        v-if="site && isLandingpageRoute"
      >
        <a
          class="nav-link"
          href="/builder/all"
        >
          <u>{{ __('Procurando o construtor avançado? Clique aqui') }}</u></a>
      </li> -->
      <li
        class="nav-item trial"
        v-if="user.trialing"
      >
        <a
          class="nav-link"
          href="/billing/plans"
        ><span class="text-primary">
           <u>TRIAL:</u>
           {{ user.days_left }} {{ __('DIAS RESTANTES') }}</span>
          <button
            class="btn btn-primary ml-15px"
            id="sign"
          >{{ __('Assine Agora') }}</button></a>
      </li>
    </ul>
    <ul class="nav ml-auto">
      <li class="nav-action d-none d-lg-block">
        <form
          class="search"
          action="/lead/all"
        >
          <input
            type="hidden"
            name="filters[0][filter]"
            value="any"
          >
          <input
            type="hidden"
            name="filters[0][operator]"
            value="has"
          >
          <input
            type="text"
            name="filters[0][query]"
            :placeholder="__('Buscar leads')"
            :class="{ 'leads-search': user.trialing }"
          >
          <!--Search(type="text" placeholder="Buscar leads" :leadSearch="user.trialing" )-->
          <button type="submit">
            <svg
              class="icon"
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="19"
              viewbox="0 0 19 19"
            >
              <g>
                <g>
                  <g>
                    <path
                      fill="#f6f5f8"
                      d="M2.328 8.485a6.156 6.156 0 1 1 6.156 6.173 6.165 6.165 0 0 1-6.156-6.173zm15.373 8.3l-3.51-3.51a7.47 7.47 0 1 0-.917.916l3.51 3.51a.648.648 0 1 0 .917-.916z"
                    />
                    <path
                      fill="none"
                      stroke="#f6f5f8"
                      stroke-miterlimit="50"
                      d="M2.328 8.485a6.156 6.156 0 1 1 6.156 6.173 6.165 6.165 0 0 1-6.156-6.173zm15.373 8.3l-3.51-3.51a7.47 7.47 0 1 0-.917.916l3.51 3.51a.648.648 0 1 0 .917-.916z"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </button>
        </form>
      </li>
      <li class="nav-action d-none d-lg-block">
        <Notification :user="user" />
      </li>
      <li class="nav-action nav-profile">
        <BDropdown
          class="nav-action nav-profile"
          toggle-class="text-decoration-none p-0"
          variant="link"
          no-caret
        >
          <template #button-content>
            <div class="d-flex flex-row align-items-center">
              <Avatar
                class="avatar"
                :name="user.name || user.email"
                width="30"
                :url="user.gravatar"
              />
              <span
                class="name"
              >
              {{ user.name.split(' ')[0] }}
              </span>
              <i
                class="fa fa-angle-down toggle-dropdown"
              />
            </div>
          </template>
          <BDropdownItem href="/user/me">
            {{ __('Meu Perfil') }}
          </BDropdownItem>
          <BDropdownItem
            href="https://salesflowcrm.movidesk.com/kb"
            target="_blank"
          >
            {{ __('Central de Ajuda') }}
          </BDropdownItem>
          <BDropdownItem @click="openResourceCenter">
            {{ __('Fale conosco') }}
          </BDropdownItem>
          <BDropdownItem
            href="/nova"
            target="_blank"
            v-if="root"
          >
            {{ __('Administração') }}
          </BDropdownItem>
          <BDropdownItem
            href="/impersonate/stop"
            v-if="user.personating"
          >
            {{ __('Parar Personificação') }}
          </BDropdownItem>
          <BDropdownItem href="/logout">
            {{ __('Sair') }}
          </BDropdownItem>
        </BDropdown>
      </li>
    </ul>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue';
// import Search from './search/Search';

export default {
  name: 'TheHeader',

  components: {
    // Search,
    BDropdown,
    BDropdownItem,
  },

  props: {
    user: {
      required: true,
      type: Object,
    },
    root: {
      default: false,
      type: Boolean,
    },
    // site: {
    //   default: false,
    //   type: Boolean,
    // },
  },

  data () {
    return {
      hasNotifications: true,
      lead: null,
    };
  },

  computed: {
    isLandingpageRoute () {
      return window.location.pathname === '/page';
    },
  },

  mounted () {
    Bus.$on('leadRetrieved', (lead) => this.lead = lead);
  },

  methods: {
    toggleCreateLeadButton () {
      Bus.$emit('createLeadButtonToggled');
    },

    toggleImportLeadButton () {
      Bus.$emit('importLeadButtonToggled');
    },

    toggleCreateDealButton () {
      Bus.$emit('createDealButtonToggled', this.lead);
    },
    openResourceCenter() {
      userGuiding.expandResourceCenter();
    },
  },
};
</script>
